import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "global-loader__message"
}




export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalLoader',
  props: {
    modelValue: { type: Boolean },
    message: {},
    backdropClosable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

// Props & emits for v-model support
const props = __props;

const emit = __emit;

function onBackdropClick() {
  if (props.backdropClosable) {
    emit('update:modelValue', false);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "gl-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "global-loader__overlay",
            role: "status",
            "aria-live": "polite",
            "aria-hidden": "false",
            onClick: _withModifiers(onBackdropClick, ["self"])
          }, [
            _createElementVNode("div", {
              class: "global-loader__panel",
              "aria-busy": __props.modelValue
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("div", {
                class: "global-loader__spinner",
                "aria-hidden": "true"
              }, null, -1)),
              (_ctx.$slots.default || __props.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createTextVNode(_toDisplayString(__props.message), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})